import React from 'react';
import { addFavoriteColor, getFavoritesFromStorage, removeFavoriteColor } from '@utils/themes';

export const useFavoriteColors = () => {
  const [favorites, setFavorites] = React.useState(() => getFavoritesFromStorage());

  const addFavorite = React.useCallback((hex) => {
    const next = addFavoriteColor(hex);
    setFavorites(next);
  }, []);

  const removeFavorite = React.useCallback((hex) => {
    const next = removeFavoriteColor(hex);
    setFavorites(next);
  }, []);

  return { favorites, addFavorite, removeFavorite };
};
